export const overlay = document.getElementById('theme-overlay')
export const hamburgerButton = document.getElementById('js-hamburger-button')
export const menuPrimary = document.getElementById('js-menu-primary')

export const themeButtons = document.querySelectorAll(
	'#js-theme-switcher .js-theme-option'
)
export const popupToggles = document.querySelectorAll('.js-popup-toggle')
export const popups = document.querySelectorAll('.js-popup')
export const fullBleedEls = document.querySelectorAll('.u-full-bleed')
